// extracted by mini-css-extract-plugin
export var cardIcon = "_7f-5";
export var cardIconUnframed = "_7f-9";
export var checkboxCard = "_7f-0";
export var checkboxCardSelected = "_7f-4";
export var disabled = "_7f-2";
export var interactive = "_7f-1";
export var outerBorder = "_7f-3";
export var spacerMedium = "_7f-8";
export var spacerSmall = "_7f-7";
export var spacerXsmall = "_7f-6";